import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getSalesLeads, saveSalesLeads } from './salesLeadsApi'
import { defaultSalesLead, defaultSalesLeadsState, SalesLeadsState } from './salesLeadsModel'
import { useSalesLeadsInvalidator } from '../../customers/customerQueries'
import { notification } from 'antd'

export const useSalesLeads = () => {
  return useQuery(['salesLeads'], getSalesLeads)
}

type SaveSalesLeadsRequest = {
  changeSet: SalesLeadsState
}

export const useSaveSalesLeadsMutation = (onSuccess: () => void) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ changeSet }: SaveSalesLeadsRequest) => saveSalesLeads(changeSet),
    onSuccess: () => {
      queryClient.invalidateQueries(['salesLeads'])
      onSuccess()
    },
    onError: () => {
      notification.error({ message: 'There was an error saving sales leads. Please try again later.' })
    }
  })
}

export const useAddSalesLeadMutation = () => {
  const queryClient = useQueryClient()
  const { invalidateSalesLeads } = useSalesLeadsInvalidator()
  return useMutation({
    mutationFn: (name: string) => saveSalesLeads({
      ...defaultSalesLeadsState(),
      addedSalesLeads: [{ ...defaultSalesLead(), name }],
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['salesLeads'])
      return invalidateSalesLeads()
    },
    onError: () => {
      notification.error({ message: 'There was an error adding the sales lead. Please try again later.' })
    }
  })
}
